import type { CourseModule } from './api';

/**
 * Which lessons a drip course keeps locked, keyed by lesson id.
 *
 * Walks the lessons in display order (modules already ordered, lessons within
 * each). A lesson is locked once we've passed any earlier lesson that isn't
 * completed — so exactly the next-to-watch lesson stays open while everything
 * after it is locked. Mirrors the server gate.
 *
 * Always takes the *whole* module list, even when the caller renders a single
 * module: a lesson's lock depends on every lesson before it in the course, not
 * just on its own module.
 *
 * A course without `sequentialUnlock` locks nothing.
 */
export function lockedLessonIds(
  modules: CourseModule[],
  sequentialUnlock: boolean,
): ReadonlySet<string> {
  const locked = new Set<string>();
  if (!sequentialUnlock) return locked;

  let blockedFromHere = false;
  for (const m of modules) {
    for (const l of m.lessons) {
      if (blockedFromHere) locked.add(l.id);
      if (!l.progress.completed) blockedFromHere = true;
    }
  }
  return locked;
}
